import { configureStore } from "@reduxjs/toolkit";
import sideBarStatus from "./slices/sidebarStatus";

const store = configureStore({
    reducer: {
        sidebarStatus: sideBarStatus
    }
})

store.subscribe(() => {
    store.getState()
    console.log(store.getState())
})

export default store